/** @graphql cc **/

import gql from 'graphql-tag';

import type { Extension } from '@atlassian/forge-ui';

import { query } from '@confluence/query-preloader-tools';

import { transformPreFilteredExtensions } from '../utils/transformForgeExtensions';

import type {
	preloadForgeAppsQuery,
	preloadForgeAppsQueryVariables,
} from './__types__/preloadForgeAppsQuery';
// eslint-disable-next-line import/no-cycle

export const preloadForgeApps = async ({
	cloudId,
	locale,
	types,
	context,
	includeHidden,
}: preloadForgeAppsQueryVariables): Promise<Extension[] | null> => {
	const { data } = await query<preloadForgeAppsQuery, preloadForgeAppsQueryVariables>({
		query: gql`
			query preloadForgeAppsQuery(
				$cloudId: ID!
				$context: ConfluenceExtensionRenderingContextInput
				$includeHidden: Boolean
				$locale: String
				$types: [String]
			) {
				confluence_forgeExtensionsByType(
					cloudId: $cloudId
					context: $context
					includeHidden: $includeHidden
					locale: $locale
					types: $types
				) {
					id
					appId
					appVersion
					appOwner
					consentUrl
					environmentId
					environmentKey
					environmentType
					migrationKey
					key
					properties {
						key
						value
					}
					egress {
						addresses
						category
						type
						inScopeEUD
					}
					scopes
					license {
						active
						capabilitySet
					}
					userAccess {
						enabled
						hasAccess
					}
					type
					installationId
					installationConfig {
						key
						value
					}
					hiddenBy
				}
			}
		`,
		variables: {
			cloudId,
			locale,
			types,
			context,
			includeHidden,
		},
	});

	return transformForgeApps(data);
};

const transformForgeApps = (data: preloadForgeAppsQuery | null): Extension[] | null => {
	if (!data || !data.confluence_forgeExtensionsByType) {
		return null;
	}

	return transformPreFilteredExtensions(data.confluence_forgeExtensionsByType);
};
